import axios, { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import { getDecryptedCookie } from "./encryptDecrpt";
import Cookies from "js-cookie";

let isHandlingAuthError = false;

const createAxiosInstance = (contentType: string): AxiosInstance => {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            'Content-Type': contentType,
        },
    });

    // 요청 인터셉터
    instance.interceptors.request.use(
        async (config) => {
            const token = getDecryptedCookie('token');
            if (token) {
                config.headers['Authorization'] = `Token ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // 응답 인터셉터
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error.response?.status;
            if (status === 401 || status === 403) {
                handleAuthError();
                return { data: { code: status } };
            }
            else if (status === 404) {
                return toast.error('시스템 점검 혹은 잘못된 접근입니다.');
            }
            else if (status === 500) {
                toast.error('axios 500에러', status);
                return { data: { code: 500 } }
            }

            return Promise.reject(error);
        }
    );

    return instance;
};

const createAxiosInstance2 = (contentType: string): AxiosInstance => {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL2,
        headers: {
            'Content-Type': contentType,
        },
    });

    // 요청 인터셉터
    instance.interceptors.request.use(
        async (config) => {
            const token = getDecryptedCookie('token');
            if (token) {
                config.headers['Authorization'] = `Token ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // 응답 인터셉터
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error.response?.status;
            if (status === 401 || status === 403) {
                handleAuthError();
                return { data: { code: status } };
            }

            else if (status === 404) {
                return toast.error('시스템 점검 혹은 잘못된 접근입니다.');
            }
            else if (status === 500) {
                toast.error('axios 500에러', status);
                return { data: { code: 500 } }
            }

            return Promise.reject(error);
        }
    );

    return instance;
};

const handleAuthError = () => {
    if (isHandlingAuthError) return;
    isHandlingAuthError = true;

    toast.error('권한이 없습니다. 다시 로그인 해주세요.');
    localStorage.removeItem('pulseUserInfo');
    localStorage.removeItem('token');
    Cookies.remove("token");

    setTimeout(() => {
        window.location.replace('/login');
        isHandlingAuthError = false;
    }, 1000);
};

export const formAxios = createAxiosInstance('multipart/form-data');
export const jsonAxios = createAxiosInstance('application/json');
export const jsonAxios2 = createAxiosInstance2('application/json');
export const formAxios2 = createAxiosInstance2('multipart/form-data');